import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, ReactiveFormsModule } from '@angular/forms';
import { ShInputTextComponent, TextValueAccessor } from '@gbr-monorepo/gbr-shui';
import { TranslateModule } from '@ngx-translate/core';
import { SeasonFormGroup } from '../../../models/season-form.model';
import { SeasonBaseFormComponent } from '../season-base-form/season-base-form.component';

@Component({
    selector: 'app-season-info',
    templateUrl: './season-info.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ShInputTextComponent, ReactiveFormsModule, TranslateModule, TextValueAccessor]
})
export class SeasonInfoComponent extends SeasonBaseFormComponent {
    public readonly seasonInfo = input.required<SeasonFormGroup['seasonInfo']>();

    protected getFormControl(): AbstractControl {
        return this.seasonInfo();
    }
}
